<template>
  <v-container>
    <v-row justify="center"><h2>Moje voľné termíny</h2></v-row>
    <v-row justify="center">
      <v-col cols="10">
        <p>
          Jednoducho si vyber dátum a čas (začiatku upratovania), kedy môžeš
          poskytnúť upratovaciu službu a klikni na tlačidlo "Pridať". Termíny,
          ktoré pridáš môžeš kedykoľvek zrušiť. Ak si niekto objedná tvoju
          službu na daný termín, objednávku môžeš schváliť alebo odmietnuť.
        </p>
        <p class="warning--text">
          <em
            >Termíny vyberaj zodpovedne. Ak si navolíš termíny tesne blízko
            seba, nemusíš stihnúť poskytnúť službu všetkým zákazníkom v
            objednanom čase, to sa môže negatívne prejaviť na tvojom
            hodnotení. Minimálny rozostup medzi termínmi je jedna hodina.</em
          >
        </p>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="10" md="6" lg=5>
        <v-date-picker
        full-width
          :first-day-of-week="1"
          locale="sk-SK"
          v-model="date"
          color="primary lighten-1"
          header-color="accent darken-1"
          :min="today"
           
        />
      </v-col>
      <v-col cols="10" md="6" lg="5">
        <v-time-picker
        full-width
          :allowed-minutes="al_minutes"
          height="150"
          v-model="time"
          format="24hr"
        ></v-time-picker>
      </v-col>
    </v-row>
    <v-row justify="space-around" align="center">
      <v-col cols="5" md="5">
        <v-text-field
          class="subtitle-2 text-center"
          label="Termín"
          readonly
          :value="`${getEuroDate(date)}, ${time || 'Vyber čas'}`"
        >
        </v-text-field>
      </v-col>
      <v-col cols="5" md="2">
        <v-btn @click="addTerm()" color="accent darken-2">Pridaj termín </v-btn>
      </v-col>
    </v-row>
    <v-row justify="space-around" class="mt-n10">
      <v-col cols="10" lg="5">
        <v-card height="100" flat>
        <v-alert type="success" :value="alert" transition="slide-y-transition">
          Termín bol úspešne pridaný.
        </v-alert>
        <v-alert type="error" :value="error" transition="slide-y-transition">
          Zadaj dátum a čas!
        </v-alert>
        <v-alert type="error" :value="alreadyAdded" transition="slide-y-transition">
          Termín musí byť vzdialený aspoň hodinu od všetkých existujúcich termínov.
        </v-alert>
        </v-card>
      </v-col>
      <v-col cols="0" lg="2"></v-col>
    </v-row>
    <v-row justify="center" class="mt-1"><h3>Tvoje voľné termíny</h3></v-row>
    <v-row justify="center">
      <v-col cols="10">
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">Dátum</th>
                <th class="text-left">Čas</th>
                <th class="text-left">Zrušiť termín</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in terms" :key="index">
                <td>{{ getEuroDate(item.date) }}</td>
                <td>{{ item.time }}</td>
                <td>
                  <v-icon 
                    color="primary"
                    @click="wantDelete(item)"
                    >
                      mdi-delete
                  </v-icon>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-col>
    </v-row>
    <v-dialog
      max-width="290"
      v-model="dialog"
    >
    
      <v-card>
        <v-card-text class="headline">
          Naozaj chceš zrušiť termín?
        </v-card-text>
        
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error darken-1"
            text
            @click="dialog = false"
          >
            Nie
          </v-btn>
          <v-btn
            color="green darken-2"
            text
            @click="deleteTerm()"
          >
            Áno
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import * as axios from "axios";
import store from "@/store/store";

export default {
  name: "TermsAdministration",
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      today: new Date().toISOString(),
      time: null,
      al_minutes: [0, 15, 30, 45],
      alert: false,
      error: false,
      alreadyAdded: false,
      terms: [],
      dialog: false,
      toDelete: null
    };
  },
  methods: {
    wantDelete(term){
      this.toDelete = term
      this.dialog = true;
    },
    deleteTerm(){
      this.dialog = false;
      const params = new URLSearchParams();
      params.append("cleaner", localStorage.getItem('loggedUserId'));
      params.append("date", this.toDelete.date);
      params.append("time", this.toDelete.time);
      axios({
        method: "post",
        url: store.state.url.concat("deleteTerm.php"),
        data: params,
      }).then(
          response => {
            if (response.data.result == true){
              console.log("deleted");
            }
          },
          error => {
            console.log(error);
          }
      )
      this.terms = this.terms.filter((datetime)=>{
        return (datetime.date !== this.toDelete.date || datetime.time !== this.toDelete.time);
      });
    },
    addTerm() {
      if(!this.time) {
        this.error = true;
        setTimeout(() => {
          this.error = false;
        }, 1500);
      }
      else if(this.dateExists()){
        this.alreadyAdded = true;
        setTimeout(() => {
          this.alreadyAdded = false;
        }, 2500);
      }
      else if (this.date && this.time) {
        const params = new URLSearchParams();
        params.append("cleaner", localStorage.getItem('loggedUserId'));
        params.append("date", this.date);
        params.append("time", this.time);
        axios({
          method: "post",
          url: store.state.url.concat("addTerm.php"),
          data: params,
        }).then(
            response => {
              if (response.data.result == true){
                console.log("deleted");
              }
            },
            error => {
              console.log(error);
            }
        )
        this.terms.push({date: this.date, time: this.time})
        this.alert = true;
        setTimeout(() => {
          this.alert = false;
        }, 1500);
        this.sortTerms();
      } 
    },
    sortTerms(){
        this.terms = this.terms.sort(
          (datetime1, datetime2)=>{
            const arr1 = datetime1.date.split("-").concat(datetime1.time.split(":"));
            const arr2 = datetime2.date.split("-").concat(datetime2.time.split(":"));
            let substraction = 0;
            for(let i = 0; i<arr1.length; i++){
              substraction = parseInt(arr1[i])-parseInt(arr2[i])
              if(substraction !== 0) return substraction;
            }
            return substraction;
          }
        );
    },
    dateExists(){
      for(let datetime of this.terms){
        if(this.date === datetime.date){
          const [h, m] = this.time.split(":");
          const [h2, m2] = datetime.time.split(":");
          if(h === h2) return true;
          if(Math.abs(h-h2 <= 1)){
            if(h < h2 && m > m2) return true;
            if(h2 < h && m2 > m) return true;
          }
        }
      }
      return false;
    },
    getEuroDate(date) {
      var myDate = new Date(date);
      return (
            ("0" + myDate.getDate()).slice(-2) + "." + ("0" + (myDate.getMonth() + 1)).slice(-2)  + "." + myDate.getFullYear()
        );
    },
    getMyTerms(){
      axios.get(store.state.url.concat('getTerms.php'), {
        params: {
          user:  localStorage.getItem('loggedUserId')
        }
      }).then((response) => {
        if(response.data.result){
          if(response.data.result == 'noTerms') {
            this.terms = [];
          }
        }else{
          this.terms = response.data;
          this.sortTerms();
        }
      })
    }
  },
  created: function(){
    this.getMyTerms();
  }
};
</script>

<style>
</style>